import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';

export class Temperature extends Model {
  @Expose() detectedAt: Date;
  @Expose() temperature: number;
  @Expose() isEmailSent: boolean;
}
